module.exports = __webpack_public_path__ + "img/next.8d9e38ef.svg";